/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
export var jove__app__policy__model__SortByColumnEnum;

(function (jove__app__policy__model__SortByColumnEnum) {
  jove__app__policy__model__SortByColumnEnum["CREATED_AT"] = "created_at";
  jove__app__policy__model__SortByColumnEnum["ACTIVE_DATE"] = "active_date";
  jove__app__policy__model__SortByColumnEnum["EXPIRATION_DATE"] = "expiration_date";
})(jove__app__policy__model__SortByColumnEnum || (jove__app__policy__model__SortByColumnEnum = {}));